// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__5MUp8","footer":"ModalFilter_footer__3kgSX"};